import React, { Suspense, useLayoutEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { ProductContextProvider } from "../pages/pre-built/products/ProductContext";
import { UserContextProvider } from "../pages/pre-built/user-manage/UserContext";
import { RedirectAs404 } from "../utils/Utils";

import Analytics from "../pages/Analytics";
import Crypto from "../pages/Crypto";
import Homepage from "../pages/Homepage";
import Invest from "../pages/Invest";

import Accordian from "../pages/components/Accordions";
import Alerts from "../pages/components/Alerts";
import Avatar from "../pages/components/Avatar";
import Badges from "../pages/components/Badges";
import Breadcrumbs from "../pages/components/Breadcrumbs";
import ButtonGroup from "../pages/components/ButtonGroup";
import Buttons from "../pages/components/Buttons";
import Cards from "../pages/components/Cards";
import Carousel from "../pages/components/Carousel";
import Dropdowns from "../pages/components/Dropdowns";
import Component from "../pages/components/Index";
import Modals from "../pages/components/Modals";
import Pagination from "../pages/components/Pagination";
import Popovers from "../pages/components/Popovers";
import Progress from "../pages/components/Progress";
import Spinner from "../pages/components/Spinner";
import Tabs from "../pages/components/Tabs";
import Toast from "../pages/components/Toast";
import Tooltips from "../pages/components/Tooltips";
import Typography from "../pages/components/Typography";
import UtilBorder from "../pages/components/UtilBorder";
import UtilColors from "../pages/components/UtilColors";
import UtilDisplay from "../pages/components/UtilDisplay";
import UtilEmbeded from "../pages/components/UtilEmbeded";
import UtilFlex from "../pages/components/UtilFlex";
import UtilOthers from "../pages/components/UtilOthers";
import UtilSizing from "../pages/components/UtilSizing";
import UtilSpacing from "../pages/components/UtilSpacing";
import UtilText from "../pages/components/UtilText";
import AdvancedControls from "../pages/components/forms/AdvancedControls";
import CheckboxRadio from "../pages/components/forms/CheckboxRadio";
import FormElements from "../pages/components/forms/FormElements";
import FormLayouts from "../pages/components/forms/FormLayouts";
import FormUpload from "../pages/components/forms/FormUpload";
import FormValidation from "../pages/components/forms/FormValidation";
import InputGroup from "../pages/components/forms/InputGroup";
import NumberSpinner from "../pages/components/forms/NumberSpinner";
import WizardForm from "../pages/components/forms/WizardForm";
import NouiSlider from "../pages/components/forms/nouislider";
import DataTablePage from "../pages/components/table/DataTable";

import ChartPage from "../pages/components/charts/Charts";
import NioIconPage from "../pages/components/crafted-icons/NioIcon";
import SVGIconPage from "../pages/components/crafted-icons/SvgIcons";
import EmailTemplate from "../pages/components/email-template/Email";
import BasicTable from "../pages/components/table/BasicTable";
import SpecialTablePage from "../pages/components/table/SpecialTable";
import Blank from "../pages/others/Blank";
import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";

import ReactToastify from "../pages/components/misc/ReactToastify";
import InvoiceDetails from "../pages/invoice/InvoiceDetails";
import InvoiceList from "../pages/invoice/InvoiceList";
import GalleryPreview from "../pages/pre-built/gallery/GalleryCardPreview";
import KycListRegular from "../pages/pre-built/kyc-list-regular/KycListRegular";
import KycDetailsRegular from "../pages/pre-built/kyc-list-regular/kycDetailsRegular";
import PricingTable from "../pages/pre-built/pricing-table/PricingTable";
import ProductCard from "../pages/pre-built/products/ProductCard";
import ProductDetails from "../pages/pre-built/products/ProductDetails";
import ProductList from "../pages/pre-built/products/ProductList";
import ProjectCardPage from "../pages/pre-built/projects/ProjectCard";
import ProjectListPage from "../pages/pre-built/projects/ProjectList";
import TransListBasic from "../pages/pre-built/trans-list/TransListBasic";
import TransListCrypto from "../pages/pre-built/trans-list/TransListCrypto";
import UserContactCardPage from "../pages/pre-built/user-manage/UserContactCard";
import UserListCompact from "../pages/pre-built/user-manage/UserListCompact";
import UserListRegularPage from "../pages/pre-built/user-manage/UserListRegular";
import UserProfileLayout from "../pages/pre-built/user-manage/UserProfileLayout";

import { useAuthContext } from "../auth/useAuthContext";
import Loading from "../common/Loading";
import CreateAdmin from "../pages/admins/CreateAdmin";
import Admins from "../pages/admins/all/Admins";
import Calender from "../pages/app/calender/Calender";
import Chat from "../pages/app/chat/ChatContainer";
import FileManager from "../pages/app/file-manager/FileManager";
import { FileManagerContextProvider } from "../pages/app/file-manager/FileManagerContext";
import Kanban from "../pages/app/kanban/Kanban";
import AppMessages from "../pages/app/messages/Messages";
import Categories from "../pages/categories/Categories";
import KnobPreview from "../pages/components/charts/KnobPreview";
import DateTimePicker from "../pages/components/forms/DateTimePicker";
import QuillPreview from "../pages/components/forms/rich-editor/QuillPreview";
import TinymcePreview from "../pages/components/forms/rich-editor/TinymcePreview";
import BeautifulDnd from "../pages/components/misc/BeautifulDnd";
import DualListPage from "../pages/components/misc/DualListbox";
import GoogleMapPage from "../pages/components/misc/GoogleMap";
import JsTreePreview from "../pages/components/misc/JsTree";
import SlickPage from "../pages/components/misc/Slick";
import SweetAlertPage from "../pages/components/misc/SweetAlert";
import CardWidgets from "../pages/components/widgets/CardWidgets";
import ChartWidgets from "../pages/components/widgets/ChartWidgets";
import RatingWidgets from "../pages/components/widgets/RatingWidgets";
import Conversations from "../pages/conversations/Conversations";
import EmailLogs from "../pages/emails/Emails";
import InvoicePrint from "../pages/invoice/InvoicePrint";
import CreateLibraryForm from "../pages/library/CreateLibraryForm";
import Library from "../pages/library/Libraries";
import LibraryCardUI from "../pages/library/LibraryCardUI";
import LibraryCategoryCardUI from "../pages/library/LibraryCategoryCardUI";
import CompletedOrders from "../pages/patients/CompletedOrders";
import CreatePatient from "../pages/patients/CreatePatientForm";
import PatientOrders from "../pages/patients/PatientOrders";
import AllPatients from "../pages/patients/all/AllPatients";
import NewPatients from "../pages/patients/new/NewOrders";
import MyPatients from "../pages/patients/all/MyPatients";
import PatientRegistration from "../pages/patients/registration/OrderRegistration";
import Reminders from "../pages/reminders/Reminders";

import Enroll from "../pages/enroll/Enroll";
import Reports from "../pages/reports/Reports";
import EnrollReport from "../pages/reports/EnrollReport";
//import UnpaidInvoice from "../pages/reports/UnpaidInvoice";

import Template from "../pages/reminders/Template";
import CreateSpecialist from "../pages/specialists/CreateSpecialist";
import AllSpecialists from "../pages/specialists/all/AllSpecialists";

import Stages from "../pages/stages/Stages";
import WorkTypes from "../pages/worktypes/WorkTypes";

const Pages = () => {
  const { user } = useAuthContext();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        {/*Dashboards*/}
      
        {/* TODO: patients part */}
        <Route exact path={`${process.env.PUBLIC_URL}/create-order`} component={PatientRegistration}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/orders-list`} component={NewPatients}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/completed-orders-list`} component={CompletedOrders}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/my-orders-list`} component={PatientOrders}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/patients`}
          render={() => (
            <UserContextProvider>
              <AllPatients />
            </UserContextProvider>
          )}
        ></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/patients/edit/:id`} render={() => <CreatePatient />}></Route>

        {/* TODO: specialists part */}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/specialists/list`}
          render={() => (
            <UserContextProvider>
              <AllSpecialists />
            </UserContextProvider>
          )}
        ></Route>
		 <Route exact path={`${process.env.PUBLIC_URL}/patients/list`} component={MyPatients}></Route>
	
		
        <Route exact path={`${process.env.PUBLIC_URL}/specialists/create`} render={() => <CreateSpecialist />}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/specialists/edit/:id`}
          render={() => <CreateSpecialist />}
        ></Route>

        {/* TODO: admins part */}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/admins/list`}
          render={() => (
            <UserContextProvider>
              <Admins />
            </UserContextProvider>
          )}
        ></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/admins/edit/:id`} render={() => <CreateAdmin />}></Route>
		/*------Aashik -----*/
		
		

        {/* TODO: work types */}
        <Route exact path={`${process.env.PUBLIC_URL}/work-types`} render={() => <WorkTypes />}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/email-template`} render={() => <Template />}></Route>

        {/* TODO: categories */}
        <Route exact path={`${process.env.PUBLIC_URL}/categories`} render={() => <Categories />}></Route>

        {/* TODO: conversations */}
        <Route exact path={`${process.env.PUBLIC_URL}/conversations`} render={() => <Conversations />}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/libraries/list`}
          render={() => (user?.role?.slug === "admin" ? <Library /> : <LibraryCategoryCardUI />)}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/libraries/create`} render={() => <CreateLibraryForm />}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/libraries/category/:id`} render={() => <LibraryCardUI />}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/libraries/edit/:id`}
          render={() => (
            <FileManagerContextProvider>
              <CreateLibraryForm />
            </FileManagerContextProvider>
          )}
        ></Route>

        <Route
          exact
          path={`${process.env.PUBLIC_URL}/libraries/view/:id`}
          render={() => <CreateLibraryForm view={true} />}
        ></Route>

        {/* TODO: invoices */}
        <Route exact path={`${process.env.PUBLIC_URL}/invoices`} render={() => <InvoiceList />}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/admins/create`} render={() => <CreateAdmin />}></Route>

        {/* TODO: reminders part */}
        <Route exact path={`${process.env.PUBLIC_URL}/reminders`} component={Reminders}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/stages`} component={Stages}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/email-logs`} component={EmailLogs}></Route>
		
		
        {/* TODO: enrollment part */}
        <Route exact path={`${process.env.PUBLIC_URL}/enroll`} component={Enroll}></Route>
		
		{/* TODO: reports part */}
        <Route exact path={`${process.env.PUBLIC_URL}/reports`} component={Reports}></Route>
		 <Route exact path={`${process.env.PUBLIC_URL}/EnrollReport`} component={EnrollReport}></Route>
		 {/* <Route exact path={`${process.env.PUBLIC_URL}/UnpaidInvoice`} component={UnpaidInvoice}></Route>*/}
		

        {/*Pre-built Pages*/}
        <Route exact path={`${process.env.PUBLIC_URL}/project-card`} component={ProjectCardPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/project-list`} component={ProjectListPage}></Route>
        <Route //Context Api added
          exact
          path={`${process.env.PUBLIC_URL}/user-list-regular`}
          render={() => (
            <UserContextProvider>
              <UserListRegularPage />
            </UserContextProvider>
          )}
        ></Route>
        <Route //Context Api added
          exact
          path={`${process.env.PUBLIC_URL}/user-list-compact`}
          render={() => (
            <UserContextProvider>
              <UserListCompact />
            </UserContextProvider>
          )}
        ></Route>
        {/* <Route //Context Api added
          exact
          path={`${process.env.PUBLIC_URL}/user-details/:id`}
          render={(props) => (
            <UserContextProvider>
              <UserDetailsPage {...props} />
            </UserContextProvider>
          )}
        ></Route> */}
        <Route exact path={`${process.env.PUBLIC_URL}/user-profile/`} component={UserProfileLayout}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/user-profile-notification/`}
          component={UserProfileLayout}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/user-profile-activity/`} component={UserProfileLayout}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/user-profile-setting/`} component={UserProfileLayout}></Route>
        <Route //Context api added
          exact
          path={`${process.env.PUBLIC_URL}/user-contact-card`}
          render={() => (
            <UserContextProvider>
              <UserContactCardPage />
            </UserContextProvider>
          )}
        ></Route>
        

        <Route // context api added
          exact
          path={`${process.env.PUBLIC_URL}/product-card`}
          render={(props) => (
            <ProductContextProvider>
              <ProductCard />
            </ProductContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/product-details/:id`}
          render={(props) => (
            <ProductContextProvider>
              <ProductDetails {...props} />
            </ProductContextProvider>
          )}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/invoice-list`} component={InvoiceList}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/invoice-details/:id`} component={InvoiceDetails}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/invoice-print/:id`} component={InvoicePrint}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/pricing-table`} component={PricingTable}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/image-gallery`} component={GalleryPreview}></Route>

        {/*Demo Pages*/}
        <Route exact path={`${process.env.PUBLIC_URL}/pages/terms-policy`} component={Terms}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/pages/faq`} component={Faq}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/pages/regular-v1`} component={Regularv1}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/pages/regular-v2`} component={Regularv2}></Route>

        {/*Application*/}
        <Route exact path={`${process.env.PUBLIC_URL}/app-messages`} component={AppMessages}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/app-chat`} component={Chat}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/app-calender`} component={Calender}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/files`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/shared`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/starred`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/recovery`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/settings`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/pricing`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-file-manager/folder/:id`}
          render={(props) => (
            <FileManagerContextProvider>
              <FileManager />
            </FileManagerContextProvider>
          )}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/app-kanban`} component={Kanban}></Route>

        {/*Components*/}
        <Route exact path={`${process.env.PUBLIC_URL}/components`} component={Component}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/accordions`} component={Accordian}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/alerts`} component={Alerts}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/avatar`} component={Avatar}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/badges`} component={Badges}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/breadcrumbs`} component={Breadcrumbs}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/button-group`} component={ButtonGroup}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/buttons`} component={Buttons}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/cards`} component={Cards}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/carousel`} component={Carousel}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/dropdowns`} component={Dropdowns}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/form-elements`} component={FormElements}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/form-layouts`} component={FormLayouts}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/checkbox-radio`} component={CheckboxRadio}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/advanced-control`}
          component={AdvancedControls}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/input-group`} component={InputGroup}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/form-upload`} component={FormUpload}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/number-spinner`} component={NumberSpinner}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/form-validation`} component={FormValidation}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/datetime-picker`} component={DateTimePicker}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/modals`} component={Modals}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/pagination`} component={Pagination}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/popovers`} component={Popovers}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/progress`} component={Progress}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/spinner`} component={Spinner}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/tabs`} component={Tabs}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/toast`} component={Toast}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/tooltips`} component={Tooltips}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/typography`} component={Typography}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/noUislider`} component={NouiSlider}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/wizard-basic`} component={WizardForm}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/quill`} component={QuillPreview}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/tinymce`} component={TinymcePreview}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/widgets/cards`} component={CardWidgets}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/widgets/charts`} component={ChartWidgets}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/widgets/rating`} component={RatingWidgets}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/slick-slider`} component={SlickPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/sweet-alert`} component={SweetAlertPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/beautiful-dnd`} component={BeautifulDnd}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/dual-list`} component={DualListPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/map`} component={GoogleMapPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/toastify`} component={ReactToastify}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/misc/jsTree`} component={JsTreePreview}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-border`} component={UtilBorder}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-colors`} component={UtilColors}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-display`} component={UtilDisplay}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-embeded`} component={UtilEmbeded}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-flex`} component={UtilFlex}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-others`} component={UtilOthers}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-sizing`} component={UtilSizing}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-spacing`} component={UtilSpacing}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/components/util-text`} component={UtilText}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/table-basic`} component={BasicTable}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/table-datatable`} component={DataTablePage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/table-special`} component={SpecialTablePage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/charts/chartjs`} component={ChartPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/charts/knobs`} component={KnobPreview}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/email-template`} component={EmailTemplate}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/nioicon`} component={NioIconPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/svg-icons`} component={SVGIconPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={Homepage}></Route>
        <Route component={RedirectAs404}></Route>
      </Switch>
    </Suspense>
  );
};
export default Pages;
